export const colours = {
	bgWhite: "#ffffff",
	bgDarkGrey: "#0E0E0E",
	highlight: "#E84115",
};
